import styled from "@emotion/styled";

export const colors: any = {
  primary: "#f23236",
  primary50: "#1B9742",
  primaryLight: "#E6EDF7",
  secondary: "#E11D48",
  danger: "#ED4337",
  white: "#ffffff",
  black: "#000",
  inputBorder: "#C8CDE0",
  brown50: "#E8E8E8",
  text: "#343F52",
  text50: "#A0A0A0",
  textGrey: "#4B5563",
  grey500: "#333333",
  placeholder: "#B9B9B9",
  borderColor: "#e9e9e9",
  childrenColor: "#fdfdfd",
  shadowColor: "#eff3f9",
  red: "#FE1B1B",
  red500: "#FD2100",
  red50: "#FFE9E6",
  success100: "#22C55E",
  success50: "#E9FFF1",
  yellow500: "#E2AF2C",
  yellow100: "#FEF0CD",
  boxShadow: `0 0 8px 0px rgba(28, 34, 42, 0.08)`,
  reject: "#E72929",
  accept: "#4CAF50",
  darkBlue: "#E9EAEF",
  foundationGrey500: "#1E1E1E",
  grey50: "#686868",
  secondaryText: "#88888C",
  lightBlue50: "#E9F1F8",
  messageInputBg: "#F5F5F599",
  text100: "#4A4A4A",
  text200: "#757575",
  fullyPaidBg: "#d9ffd9",
  fullyPaidText: "#2c8000",
};
export const orange: any = {
  orange50: "#ffeAeb", // rgb(255, 234, 235)
  orange100: "#ffbfc0", // rgb(255, 191, 192)
  orange200: "#ffa0a2", // rgb(255, 160, 162)
  orange300: "#ff7578", // rgb(255, 117, 120)
  orange400: "#ff5a5d", // rgb(255, 90, 93)
  orange500: "#ff3135", // rgb(255, 49, 53)
  orange600: "#e82d30", // rgb(232, 45, 48)
  orange700: "#b52326", // rgb(181, 35, 38)
  orange800: "#8c1b1d", // rgb(140, 27, 29) //for text
  orange900: "#6b1516", // rgb(107, 21, 22)
};

export const subscription = {
  subscribed: "#ebfcff",
  active: "#defff3",
  expired: "#fef8f5",
  expiring: "#fef9db",
};
export const createTheme = () => {
  const theme = {
    colors,
    orange,
    subscription,
  };

  return theme;
};

const theme = createTheme();
export default theme;
